import { create } from "zustand";
import { devtools } from "zustand/middleware";
import createSelectors from "./selectors";

type TFile = {
  key: string;
  file: {
    name: string;
    size: number;
  };
  pdfDocument: object;
  password: string;
  hash: string;
};

type Result = {
  fileName: string;
  fileUrl: string;
  fileSize: number;
};

type UploadFileResponse = {
  name: string;
  hash: string;
  size: number;
};

interface EditorState {
  isReady: boolean;
  setReady: (isReady: boolean) => void;

  step: number;
  setStep: (step: number) => void;

  file: TFile | null;
  // uploadFileResponse:
  htmlFilename: string | null;

  uploadFileResponce: UploadFileResponse | null;
  setUploadFileResponce: (uploadedFileResponce: UploadFileResponse) => void;

  setFile: (file: TFile) => void;

  result: Result | null;
  setResult: (result: Result) => void;

  isError: boolean;
  setIsError: (isError: boolean) => void;

  isUploadError: boolean;
  setIsUploadError: (isUploadError: boolean) => void;

  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;

  handleGoToStep3: (result: Result) => void;
  reset: () => void;
}

// Стор для всего того что связано с редактированием PDF
const useEditorStore = create<EditorState>()(
  devtools(
    (set) => ({
      step: 1,
      isError: false,
      isUploadError: false,
      isEditing: false,
      file: null,
      result: null,
      htmlFilename: null,
      uploadFileResponce: null,
      isReady: false,

      setReady: (isReady: boolean) => set({ isReady }),
      setUploadFileResponce(uploadFileResponce) {
        set({ uploadFileResponce });
      },

      setStep: (step: number) => set({ step }),
      setFile: (file: TFile) => set({ file }),
      setResult: (result: Result) => set({ result }),
      setIsError: (isError: boolean) => set({ isError }),
      setIsUploadError: (isUploadError: boolean) => set({ isUploadError }),
      setIsEditing: (isEditing: boolean) => set({ isEditing }),

      handleGoToStep3: (result: Result) => set({ step: 3, result }),
      reset: () => {
        set({
          step: 1,
          file: null,
          htmlFilename: null,
          result: null,
          isError: false,
          isUploadError: false,
          isEditing: false,
          isReady: false,
        });
      },
    }),
    { name: "editor-store" }
  )
);

export default createSelectors(useEditorStore);
